const API_URL = process.env.REACT_APP_API_URL 
const INTERACTIVE_INPUT_ERROR = "Interactive input is not allowed. Use hardcoded values instead."

const interactiveInputPatterns = {
  javascript: [/\bprompt\s*\(/, /\bconfirm\s*\(/, /\breadline\s*\(/, /\bprocess\.stdin\b/],
  python: [/\binput\s*\(/],
  php: [/\breadline\s*\(/, /\bfgets\s*\(\s*STDIN\s*\)/, /\bSTDIN\b/, /\$argv\b/],
}

export const validateNoInteractiveInput = (language, code) => {
  const patterns = interactiveInputPatterns[language] || []
  return patterns.some((pattern) => pattern.test(code))
    ? { isValid: false, error: INTERACTIVE_INPUT_ERROR }
    : { isValid: true }
}

export const codeApi = {
  // Execute code using Piston API
  decodeHtmlEntities: (text) => {
    const entities = {
      '&lt;': '<',
      '&gt;': '>',
      '&amp;': '&',
      '&quot;': '"',
      '&#39;': "'",
      '&nbsp;': ' '
    };
    return text.replace(/&[^;]+;/g, entity => entities[entity] || entity);
  },

  executeCode: async (language, code, input = '') => {
    try {
      // First decode any HTML entities in the code
      const decodedCode = codeApi.decodeHtmlEntities(code);
      const validation = validateNoInteractiveInput(language, decodedCode);

      if (!validation.isValid) {
        return {
          success: false,
          output: '',
          error: validation.error
        };
      }

      const response = await fetch(`${API_URL}/compiler/execute`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          language,
          code: decodedCode,
          input
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error executing code:', error);
      throw error;
    }
  },

  // Get supported languages
  getSupportedLanguages: async () => {
    try {
      const response = await fetch(`${API_URL}/compiler/languages`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error getting languages:', error);
      throw error;
    }
  }
};
